import * as FilterActions from '../actions/filter.actions';
import { FilterModel, TypesFilter } from '../../models';

export type Action = FilterActions.All;

export interface FilterState {
  filter: FilterModel;
};

const defaultTypesFilter: TypesFilter = { // all are active by default
  weir: true,
  dam: true,
  culvert: true,
  ford: true,
  sluice_gate: true,
  ramp: true,
  other: true
};

export const defaultState: FilterState = {
  filter: {
    country: '',
    types: defaultTypesFilter,
  }
};

export const FilterReducer = (state: FilterState = defaultState, action: Action): FilterState => {
  switch (action.type) {
    case FilterActions.UPDATE_FILTER: {
      return {
          ...state,
          filter: action.filter
        };
    }

    case FilterActions.UPDATE_COUNTRY_FILTER: {
      const { country } = action;
      return {
        ...state,
        filter: {
          ...state.filter,
          country
        }
      };
    }

    case FilterActions.TOGGLE_FILTER_TYPE: {
      const { toggledType } = action;
      const previousTypes = state.filter.types;
      return {
        ...state,
        filter: {
          ...state.filter,
          types: {
            ...previousTypes,
            [toggledType]: !previousTypes[toggledType]
          }
        }
      };
    }

    default: {
        return state;
    }
  }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/reducers/filter.reducer.ts